import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "@/core/utils/date";
import { DetailedUserWithStats } from "@/user/user.d";

export const LastReferralDateCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Last referral date",
  accessorFn: (row) => formatDate(row.stats?.last_referral_date),
  size: 170,
});
